export default "__VITE_ASSET__COsPyk95__"